import initialState from './initialState';
import * as types from './actionTypes';
// eslint-disable-next-line import/no-cycle
import {
  ProjectTemplatesState,
  ProjectTemplatesActions,
  FetchProjectTemplatesSuccess,
  FetchProjectTemplatesError,
} from './types';

const handleFetchProjectTemplatesListRequest = (
  state: ProjectTemplatesState,
) => ({
  ...state,
  isLoading: true,
  error: null,
});

const handleFetchProjectTemplatesListSuccess = (
  state: ProjectTemplatesState,
  action: FetchProjectTemplatesSuccess,
) => ({
  ...state,
  list: action.payload,
  isLoading: false,
  error: null,
});

const handleFetchProjectTemplatesListError = (
  state: ProjectTemplatesState,
  action: FetchProjectTemplatesError,
) => ({
  ...state,
  isLoading: false,
  error: action.error,
});

export default (
  state: ProjectTemplatesState = initialState,
  action: ProjectTemplatesActions,
): ProjectTemplatesState => {
  if (!action) {
    return state;
  }
  switch (action.type) {
    case types.FETCH_PROJECT_TEMPLATES_REQUEST:
      return handleFetchProjectTemplatesListRequest(state);
    case types.FETCH_PROJECT_TEMPLATES_SUCCESS:
      return handleFetchProjectTemplatesListSuccess(state, action);
    case types.FETCH_PROJECT_TEMPLATES_ERROR:
      return handleFetchProjectTemplatesListError(state, action);
    default:
      return state;
  }
};
